module.exports = __webpack_public_path__ + "img/2-kilo-pink.89323303.svg";